'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { ResourceProps } from './Resource';

const SanitizedContent = dynamic(() => import('./SanitizedContent'), {
  ssr: false,
});

export default function ClientResource({
  value,
  replaceValues,
}: ResourceProps) {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  if (!hydrated) return null;

  return <SanitizedContent value={value ?? ''} replaceValues={replaceValues} />;
}
